import RoomDisconnectedPage from 'pages/RoomDisconnectedPage/RoomDisconnectedPage';
import { FeatureFlag } from 'utils/Constants';
import lazyWithRetry from 'utils/lazyWithRetry';

import { createRoutes } from './utils/createRoute';
import withBrowserCheck from './utils/withBrowserCheck';
import withFeatureFlag from './utils/withFeatureFlag';
import withPageWrapper from './utils/withPageWrapper';
import withSidebarWrapper from './utils/withSidebarWrapper';

const pages = {
  UnsupportedBrowser: lazyWithRetry(() => import('modules/UnsupportedBrowser/UnsupportedBrowser')),
  RoomsPage: lazyWithRetry(() => import('pages/RoomsPage/RoomsPage')),
  RoomPage: lazyWithRetry(() => import('pages/RoomPage/RoomPage')),
  RoomEndedPage: lazyWithRetry(() => import('pages/RoomEndedPage/RoomEndedPage')),
  RoomTerminatedPage: lazyWithRetry(() => import('pages/RoomTerminatedPage/RoomTerminatedPage')),
  AuthenticationPage: lazyWithRetry(() => import('pages/AuthenticationPage/AuthenticationPage')),
  DiagnosticsPage: lazyWithRetry(() => import('pages/DiagnosticsPage/DiagnosticsPage')),
  CalendarPage: lazyWithRetry(() => import('pages/CalendarPage/CalendarPage')),
};

export default createRoutes([
  {
    path: '/',
    component: pages.RoomsPage,
    hocs: [withSidebarWrapper(), withPageWrapper()],
  },
  {
    path: '/calendar',
    component: pages.CalendarPage,
    hocs: [withSidebarWrapper(), withPageWrapper(), withFeatureFlag(FeatureFlag.FE_ENABLE_CALENDAR_VIEW_PERM)],
  },
  {
    path: '/unsupported-browser',
    component: pages.UnsupportedBrowser,
  },
  {
    path: ['/:inviteToken', '/rooms/:roomId'],
    component: pages.RoomPage,
    hocs: [withBrowserCheck],
    children: [
      { path: '/end', component: pages.RoomEndedPage },
      { path: '/disconnected', element: <RoomDisconnectedPage /> },
      { path: '/terminated', component: pages.RoomTerminatedPage },
    ],
  },

  {
    path: '/auth',
    component: pages.AuthenticationPage,
    hocs: [withPageWrapper()],
  },
  {
    path: '/test',
    component: pages.DiagnosticsPage,
    hocs: [withPageWrapper()],
  },
]);
